 // helper func to turn getExifDate() (or exifr) gives you into a real Date object
 function normalizeExifDate(raw) {
    if (!raw) return null;                     // undefined | null | ''
    if (raw instanceof Date && !isNaN(raw)) {
      return raw;
    }

    if (typeof raw === 'string') {
      // 1) Handle the "YYYY:MM:DD HH:MM:SS" flavour
      if (/^\d{4}:\d{2}:\d{2}/.test(raw)) {
        // convert “YYYY:MM:DD HH:MM:SS” → “YYYY‑MM‑DDTHH:MM:SS”
        const isoLike = raw.replace(
          /^(\d{4}):(\d{2}):(\d{2})/,
          (_, y, m, d) => `${y}-${m}-${d}T`
        ).replace(' ', '');
        const dt = new Date(isoLike);
        if (!isNaN(dt)) return dt;
      }

      // 2) Any other string → let Date() try
      const dt = new Date(raw);
      if (!isNaN(dt)) return dt;
    }

    // Could not parse
    return null;
  }

    // try to squeeze a usable Date out of common camera / phone filename patterns.  Returns a Date object ‑ or null if no match.
  function parseDateFromFilename(fileName = '') {
    const candidates = [
  
      // IMG_20240418_163012.jpg  →  YYYY MM DD HH MM SS
      /IMG[_-]?(\d{4})(\d{2})(\d{2})[_-](\d{2})(\d{2})(\d{2})/i,
  
      // 2024‑04‑18_16‑30‑12 or 20240418‑163012
      /(\d{4})[-_]?(\d{2})[-_]?(\d{2})[_ -]?(\d{2})(\d{2})(\d{2})/,
  
      // plain date only (no time)  20240418
      /(\d{4})(\d{2})(\d{2})/,
    ];
  
    for (const rx of candidates) {
      const m = fileName.match(rx);
      if (!m) continue;
  
      const [ , Y, M, D, h = '12', mnt = '00', s = '00' ] = m;
      const dt = new Date(
        Number(Y), Number(M) - 1, Number(D),   // year month day
        Number(h), Number(mnt), Number(s)      // hour minute second
      );
  
      if (!isNaN(dt)) return dt;
    }
  
    return null;   // nothing matched
  }

  // build a JS date from GPSDateStamp / GPSTimeStamp EXIF pair
  function dateFromGps(gpsDate, gpsTime = '12:00:00') {
    if (!gpsDate) return null;

    // zero‑pad each time component so '20:26:4' → '20:26:04'
    const t = gpsTime.split(':')
                    .map(v => v.padStart(2, '0'))
                    .join(':');

    // "YYYY:MM:DD HH:MM:SS"   → reuse our normaliser
    return normalizeExifDate(`${gpsDate} ${t}`);
  }

export { normalizeExifDate, dateFromGps, parseDateFromFilename };
